import React from "react";
import Sidebar from "./Sidebar";
import UserHeader from "./UserHeader";
import "./UserLayout.css"; // Optional for layout-specific styles

const UserLayout = ({ children }) => {
  return (
    <div className="layout">
      <Sidebar />
      <div className="content">
        <UserHeader />
        <main>{children}</main>
      </div>
    </div>
  );
};

export default UserLayout;
